import React, {Component} from 'react'
import Hls from 'hls.js'

class CameraLiveStream extends Component {
  constructor(props) {
    super(props);
    let safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    this.state = {
      url: this.props.target,
      hls: null,
      isSafari: safari,
      intervalId: 0,
      onErr: false
    };
  }

  componentDidMount() {
    if (Hls.isSupported() && !this.state.isSafari) {
      let video = document.getElementById(this.props.videoID);
      let hls = new Hls();
      hls.loadSource(this.state.url);
      hls.attachMedia(video);
      hls.on(Hls.Events.MANIFEST_PARSED, function() {
        let playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.then(_ => {
            // Automatic playback started!
            // Show playing UI.
          }).catch(error => {
            // Auto-play was prevented
            // Show paused UI.
          });
        }
      });
      this.setState({hls: hls});
    }
  }

  componentWillUnmount() {
    if (!this.state.isSafari) {
      this.state.hls.destroy();
    }
  }

  render() {
    const {isSafari, url} = this.state
    const {videoID} = this.props
    const content = isSafari
      ? <video id={videoID} src={url} width="100%" height="100%" controls="controls"></video>
      : <video id={videoID} width="100%" height="100%" preload="none" controls="controls"></video>;
    return content;
  }
}

export default CameraLiveStream;



// WEBPACK FOOTER //
// ./src/components/CameraLiveStream.js